/**
 * O texto principal de uma célula de tabela: 16px, o piso de letra de corpo. O DataTable comum
 * renderiza texto plano em 14px, então a coluna que carrega a informação da linha passa por aqui.
 */
import React from 'react';
import { Typography } from '@mui/material';

export const MainText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography variant="body1" component="div" sx={{ fontSize: '1rem' }}>
    {children}
  </Typography>
);
